module.exports = __webpack_public_path__ + "img/team-member-active.330f55b3.svg";